import { Hero03podcast } from './Images.js';
import HeroImage from './components/HeroImage';
import './css/App.css';

import { useDocumentTitle } from "./hooks/useDocumentTitle";
import { useMediaQuery } from 'react-responsive';

function Podcasts() {
  
  useDocumentTitle("Podcast");
  const isMobile = useMediaQuery({ query: `(max-width: 960px)` });

  return (
      <div className="sectionbody">
        <div className={isMobile ? "hero-image-area-mobile" : "hero-image-area"}>
            <HeroImage src={Hero03podcast} alt="Seeking a Scientist Podcast with Kate the Chemist" />
        </div>

        <div className={isMobile ? "intro-paragraph-area-mobile" : "intro-paragraph-area"}>
            <h1>Podcast</h1>
            <h2><em>Seeking a Scientist with Kate the Chemist</em></h2>
            <p>The future is scary, but it doesn't have to be!  Host Dr. Kate Biberdorf (aka Kate the Chemist) is seeking scientists to guide us into the great unknown.  From fungus zombies to feeling young forever, we're puzzling out what our world could look like — and how we can get ready.  A podcast from <a href="https://www.kcur.org/kcurstudios">KCUR Studios</a> and the <a href="https://www.npr.org/podcasts/2047/science">NPR Podcast network</a>.</p>
        </div>

        <div className="blue-bg-area">
          <div className="podcastplayer-container">
            <iframe className="podcastplayer" allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write" frameBorder="0" height="450" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation" src="https://embed.podcasts.apple.com/us/podcast/seeking-a-scientist/id1677872366"></iframe>
        </div>
        </div>

      </div>


  );
}

export default Podcasts;
